import React from 'react';

/**
 * Fängt Render-Fehler ab und zeigt eine Fallback-UI statt komplett abzustürzen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Fehler abgefangen:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '2rem',
          maxWidth: '600px',
          margin: '2rem auto',
          fontFamily: 'system-ui, sans-serif',
          border: '1px solid #ef4444',
          borderRadius: '8px',
          backgroundColor: '#fef2f2'
        }}>
          <h2 style={{ color: '#dc2626', marginTop: 0 }}>Etwas ist schiefgelaufen</h2>
          <p>Die Anwendung ist aufgrund eines Fehlers angehalten. Bitte laden Sie die Seite neu.</p>
          <details style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
            <summary style={{ cursor: 'pointer' }}>Technische Details</summary>
            <pre style={{ overflow: 'auto', marginTop: '0.5rem', padding: '0.5rem', background: '#fff', borderRadius: '4px' }}>
              {this.state.error?.toString()}
            </pre>
          </details>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: '1rem',
              padding: '0.5rem 1rem',
              backgroundColor: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            Seite neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
